import _implicitStylesheets from "./messageBoxNotification.css";
import _implicitScopedStylesheets from "./messageBoxNotification.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _i18nLink from "i18n/link";
import _pageLink from "page/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"} class="notification-link${0}"${"a0:title"}${"a0:target"}${2}><span class="slds-truncate${0}"${"a1:title"}${2}>${"t2"}</span></a>`;
const stc0 = {
  "role": "dialog"
};
const stc1 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_horizontal": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "slds-m-right_medium": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_vertical": true
  },
  key: 5
};
const stc4 = {
  classMap: {
    "slds-col": true,
    "notification-text": true
  },
  key: 6
};
const stc5 = {
  classMap: {
    "slds-col": true
  },
  key: 8
};
const stc6 = {
  key: 9
};
const stc7 = {
  classMap: {
    "slds-m-left_medium": true
  },
  key: 12
};
const stc8 = {
  "close-icon": true,
  "slds-size_1-of-12": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.cssNotificationClass),
    attrs: stc0,
    key: 0
  }, [api_element("div", stc1, [api_element("div", stc2, [api_element("span", {
    className: api_normalize_class_name($cmp.iconClass),
    key: 3
  }, [api_custom_element("c360-icon", _c360Icon, {
    props: {
      "iconName": $cmp.iconName,
      "iconDescription": $cmp.type
    },
    key: 4
  })])]), api_element("div", stc3, [api_element("div", stc4, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.message,
      "target": $cmp.linkTarget
    },
    key: 7
  })]), $cmp.action ? api_element("div", stc5, [api_custom_element("page-link", _pageLink, stc6, [api_static_fragment($fragment1, 11, [api_static_part(0, {
    attrs: {
      "href": $cmp.action.href,
      "title": $cmp.action.name,
      "target": $cmp.action.target
    }
  }, null), api_static_part(1, {
    attrs: {
      "title": $cmp.action.name
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.action.name))])])]) : null]), api_element("div", stc7, [api_custom_element("c360-icon", _c360Icon, {
    classMap: stc8,
    attrs: {
      "data-index": $cmp.indexClose
    },
    props: {
      "iconName": "utility:close",
      "iconDescription": $cmp.labels.close,
      "size": "small",
      "iconClass": "close"
    },
    key: 13,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.closeCallback))
    }
  })])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-qms3s88dpi";
tmpl.legacyStylesheetToken = "appx-messageBox_messageBoxNotification";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
